import { render, staticRenderFns } from "./trendBar.vue?vue&type=template&id=60578499&scoped=true&"
import script from "./trendBar.vue?vue&type=script&lang=js&"
export * from "./trendBar.vue?vue&type=script&lang=js&"
import style0 from "./trendBar.vue?vue&type=style&index=0&id=60578499&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60578499",
  null
  
)

export default component.exports